<div (click)="$event.stopPropagation()" class="me-2">
    <div (click)="goToOrganisationSettings()"
      class="avatar border d-flex align-items-center justify-content-center position-relative"
      [ngStyle]="{'background-color': 'white'}">
      <mat-icon matTooltip="Organisation Settings">settings</mat-icon>
    </div>
  </div>